export const routes = {
  deliveriesLean: '/deliverieslite',
  deliveriesDetailed: '/deliveries',
  activeDeliveries: '/deliveries/active',
  activeDeliveriesWithParam: '/deliveries/active/:deliveryId',
  pastDeliveries: '/deliveries/past',
  pastDeliveriesWithParam: '/deliveries/past/:deliveryId',
  deliveriesOtp: '/deliveries/otp',
  activeDeliveriesOtp: '/deliveries/otp/active',
  activeDeliveriesOtpWithParam: '/deliveries/otp/active/:deliveryId',
  profile: '/profile',
  faq: '/faq',
  search: '/search',
  deliveriesDashboard: '/deliveries/dashboard',
  addresses: '/addresses',
  payments: '/payments',
  segmentationStart: '/onboarding/start',
  newMerchantDetails: '/onboarding/new-merchant-details',
  existingMerchantDetails: '/onboarding/business-name'
};

export function getRoute(route = '') {
  const key = Object.keys(routes).find(key => key.toLowerCase() === route.toLowerCase());
  return routes[key as keyof typeof routes] || routes.deliveriesDetailed;
}

export enum RouteGroup {
  ON_DEMAND = 'ON_DEMAND',
  DEDICATED_FLEET = 'DEDICATED_FLEET',
  OTHER = 'OTHER'
}

export function getRouteGroup(pathname: string | string[]) {
  if (pathname !== '/') {
    if (
      pathname === routes.deliveriesDetailed ||
      pathname.includes(routes.activeDeliveries) ||
      pathname.includes(routes.pastDeliveries) ||
      pathname.includes(routes.deliveriesDashboard)
    ) {
      return RouteGroup.ON_DEMAND;
    }
    if (pathname === routes.deliveriesOtp || pathname.includes(routes.activeDeliveriesOtp)) {
      return RouteGroup.DEDICATED_FLEET;
    }
  }
  return RouteGroup.OTHER;
}

export function getRouteName(pathname: string) {
  let result = '/';
  if (pathname === '/') {
    return result;
  }

  const exactMatch = Object.entries(routes).some(([key, value]) => {
    if (value === pathname) {
      result = key;
      return true;
    }
  });
  if (!exactMatch) {
    const weakCheck = [
      { route: routes.activeDeliveries, name: 'activeDeliveries' },
      { route: routes.pastDeliveries, name: 'pastDeliveries' }
    ];
    weakCheck.some(({ route, name }) => {
      if (pathname.includes(route)) {
        result = name;
        return true;
      }
    });
  }
  return result;
}

export const checkIsRestrictedForDisabledUsers = (pathname: string | string[]) => {
  const restrictedRoutes = [
    routes.activeDeliveriesWithParam,
    routes.activeDeliveries,
    routes.deliveriesOtp,
    routes.activeDeliveriesOtp,
    routes.activeDeliveriesOtpWithParam,
    routes.deliveriesDetailed,
    `${routes.deliveriesDetailed}/`
  ];

  if (restrictedRoutes.some(route => route === pathname)) {
    return true;
  }

  return pathname.includes(routes.activeDeliveries) || pathname.includes(routes.activeDeliveriesOtp);
};

export const checkIsRestrictedForNonPortalUser = (pathname: string | string[]) => {
  const restrictedRoutes = [routes.deliveriesOtp, routes.deliveriesDetailed, `${routes.deliveriesDetailed}/`];

  return restrictedRoutes.some(route => route === pathname);
};
